import React from 'react';
import { Form, FormLabel } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store';
import { setParams } from '../reducers/paramsReducer';
import { usePatternThemes } from './patternThemes';
import { analytics } from '../utils/analytics';

// Pattern filter: show only games that contain a given move pattern (a CommentaryTheme). Options are
// the webmaster-enabled set behind the /patterns pages; selecting one is also how a /patterns deep
// link lands.
export default function GamesFiltersPattern(): React.ReactNode {
  const { pattern } = useAppSelector((state) => state.paramsReducer.params);
  const dispatch = useAppDispatch();
  const themes = usePatternThemes();

  return (
    <>
      <FormLabel>Pattern</FormLabel>
      <Form.Select
        className="cm-filter-select"
        value={pattern ?? ''}
        onChange={(e) => {
          const value = e.target.value === '' ? null : e.target.value;
          dispatch(setParams({ pattern: value }));
          if (value != null) {
            analytics.track('select_pattern', { pattern: value, ui_source: 'spa_filter' });
          }
        }}
      >
        <option value="">Any pattern</option>
        {themes.map(({ theme, label }) => (
          <option key={theme} value={theme}>
            {label}
          </option>
        ))}
      </Form.Select>
    </>
  );
}
